import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";

if (document.getElementById("frontPage") !== null) {
  const fvSlider = new Swiper("#fvSlider", {
    effect: "fade",
    loop: true,
    slidesPerView: 1,
    speed: 1500,
    autoplay: {
      delay: 3000,
    },
  });

  const projectSlider = new Swiper("#projectSlider", {
    effect: "fade",
    loop: true,
    slidesPerView: 1,
    speed: 1500,
    autoplay: {
      delay: 5000,
    },
  });

  const staffSlider = new Swiper("#staffSlider", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 1500,
    autoplay: {
      delay: 5000,
    },

    breakpoints: {
      768: {
        slidesPerView: 4,
      },
    },

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}

if (document.getElementById("factory") !== null) {
  const factorySlider = new Swiper("#factorySlider", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 30,
    speed: 1000,
    autoplay: {
      delay: 3000,
    },

    breakpoints: {
      768: {
        slidesPerView: 2.2,
      },
    },

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}

if (document.getElementById("staff") !== null) {
  const factorySlider = new Swiper("#scheduleSlider", {
    loop: true,
    slidesPerView: 1,
    speed: 1000,

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}
